var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Col',[_c(_setup.BillingSectionHeader,{attrs:{"videoUrl":"","sub-title":_setup.subTitle,"learnMoreLink":_setup.learnMoreLink,"title":"Build for your customers.","howItWorksExplanations":_setup.howItWorksExplanations}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }